var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCouponsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 7.5C2.32979 7.5 2.96567 7.76339 3.43451 8.23223C3.90336 8.70107 4.16675 9.33696 4.16675 10C4.16675 10.663 3.90336 11.2989 3.43451 11.7678C2.96567 12.2366 2.32979 12.5 1.66675 12.5V14.1667C1.66675 14.6087 1.84234 15.0326 2.1549 15.3452C2.46746 15.6577 2.89139 15.8333 3.33341 15.8333H16.6667C17.1088 15.8333 17.5327 15.6577 17.8453 15.3452C18.1578 15.0326 18.3334 14.6087 18.3334 14.1667V12.5C17.6704 12.5 17.0345 12.2366 16.5656 11.7678C16.0968 11.2989 15.8334 10.663 15.8334 10C15.8334 9.33696 16.0968 8.70107 16.5656 8.23223C17.0345 7.76339 17.6704 7.5 18.3334 7.5V5.83333C18.3334 5.3913 18.1578 4.96738 17.8453 4.65482C17.5327 4.34226 17.1088 4.16666 16.6667 4.16666H3.33341C2.89139 4.16666 2.46746 4.34226 2.1549 4.65482C1.84234 4.96738 1.66675 5.3913 1.66675 5.83333V7.5Z",
    stroke: "#00C49A",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 4.16666V5.83333",
    stroke: "#00C49A",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667V15.8333",
    stroke: "#00C49A",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 9.16666V10.8333",
    stroke: "#00C49A",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCouponsIcon);
export default __webpack_public_path__ + "static/media/active-coupons-icon.b480d4c5edcbe0d6a2a9bc519c22d371.svg";
export { ForwardRef as ReactComponent };